"use strict";

exports.__esModule = true;
exports.default = getNumberWithMaxDecimalPlaces;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.constructor");

function getNumberWithMaxDecimalPlaces(value, places) {
  var toFixedRegex = new RegExp("^-?\\d+(?:.\\d{0,".concat(places, "})?")); // eslint-disable-line no-useless-escape

  return parseFloat(value.toString().match(toFixedRegex)[0]);
}